 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","app-side-navigation":"app-side-navigation","buch-bestell":"buch-bestell","buch-listen":"buch-listen","buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264":"buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264","buchscanner":"buchscanner","buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2":"buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2","buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor":"buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor","buchverlagsverkaeufe~vca-fehler-liste":"buchverlagsverkaeufe~vca-fehler-liste","buchverlagsverkaeufe":"buchverlagsverkaeufe","convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf":"convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf","convenience-verkauf":"convenience-verkauf","wfmonitor":"wfmonitor","regalkontrolle":"regalkontrolle","buecher":"buecher","kassencheck":"kassencheck","presse-rechnungen":"presse-rechnungen","statistiken":"statistiken","vca-fehler":"vca-fehler","zeitschriften":"zeitschriften","BuchListenListe":"BuchListenListe","BuchVerlagsVerkaeufeDetail":"BuchVerlagsVerkaeufeDetail","BuchungsMonitorDetail":"BuchungsMonitorDetail","BarcodeButton":"BarcodeButton","BuchAnzeige":"BuchAnzeige","ConvenienceAnzeige":"ConvenienceAnzeige","PresseAnzeige":"PresseAnzeige","presse-rechnung-kopf":"presse-rechnung-kopf","liste-unfertige-rechnungen":"liste-unfertige-rechnungen","datumsbereich-auswahl":"datumsbereich-auswahl","vca-fehler-liste":"vca-fehler-liste","excel-support":"excel-support","bewegung-chart":"bewegung-chart","verlag-selector":"verlag-selector","vca-fehler-fixer":"vca-fehler-fixer"}[chunkId]||chunkId) + "." + {"about":"9457276f","app-side-navigation":"3ed24ec6","buch-bestell":"da91e9c6","buch-listen":"fa59d7af","buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264":"5b5bbf5d","buchscanner":"802dc0be","buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2":"66579fbc","buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor":"097e4fe2","buchverlagsverkaeufe~vca-fehler-liste":"9180ab4a","buchverlagsverkaeufe":"718cdef6","convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf":"f329e056","convenience-verkauf":"78f3f8c5","wfmonitor":"b2eb5cde","regalkontrolle":"aa399420","buecher":"424d76af","kassencheck":"63a0b57c","presse-rechnungen":"b4f2d592","statistiken":"206f5bb1","vca-fehler":"cf2a3b62","zeitschriften":"e2354408","BuchListenListe":"b20b8740","BuchVerlagsVerkaeufeDetail":"4a11704a","BuchungsMonitorDetail":"404b5f5c","BarcodeButton":"ff8e2200","BuchAnzeige":"9df01760","ConvenienceAnzeige":"af484ced","PresseAnzeige":"b3d47374","presse-rechnung-kopf":"8c42d10a","liste-unfertige-rechnungen":"47d4d669","datumsbereich-auswahl":"597f5f16","vca-fehler-liste":"1ae4daec","excel-support":"f1aacd53","bewegung-chart":"20aad374","verlag-selector":"c47d1837","vca-fehler-fixer":"23f87b0f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"app-side-navigation":1,"buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264":1,"buchscanner":1,"buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor":1,"buchverlagsverkaeufe~vca-fehler-liste":1,"buchverlagsverkaeufe":1,"convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf":1,"convenience-verkauf":1,"wfmonitor":1,"regalkontrolle":1,"buecher":1,"kassencheck":1,"vca-fehler":1,"BuchVerlagsVerkaeufeDetail":1,"BuchungsMonitorDetail":1,"BarcodeButton":1,"BuchAnzeige":1,"ConvenienceAnzeige":1,"PresseAnzeige":1,"presse-rechnung-kopf":1,"liste-unfertige-rechnungen":1,"datumsbereich-auswahl":1,"vca-fehler-liste":1,"bewegung-chart":1,"verlag-selector":1,"vca-fehler-fixer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","app-side-navigation":"app-side-navigation","buch-bestell":"buch-bestell","buch-listen":"buch-listen","buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264":"buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264","buchscanner":"buchscanner","buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2":"buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2","buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor":"buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor","buchverlagsverkaeufe~vca-fehler-liste":"buchverlagsverkaeufe~vca-fehler-liste","buchverlagsverkaeufe":"buchverlagsverkaeufe","convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf":"convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf","convenience-verkauf":"convenience-verkauf","wfmonitor":"wfmonitor","regalkontrolle":"regalkontrolle","buecher":"buecher","kassencheck":"kassencheck","presse-rechnungen":"presse-rechnungen","statistiken":"statistiken","vca-fehler":"vca-fehler","zeitschriften":"zeitschriften","BuchListenListe":"BuchListenListe","BuchVerlagsVerkaeufeDetail":"BuchVerlagsVerkaeufeDetail","BuchungsMonitorDetail":"BuchungsMonitorDetail","BarcodeButton":"BarcodeButton","BuchAnzeige":"BuchAnzeige","ConvenienceAnzeige":"ConvenienceAnzeige","PresseAnzeige":"PresseAnzeige","presse-rechnung-kopf":"presse-rechnung-kopf","liste-unfertige-rechnungen":"liste-unfertige-rechnungen","datumsbereich-auswahl":"datumsbereich-auswahl","vca-fehler-liste":"vca-fehler-liste","excel-support":"excel-support","bewegung-chart":"bewegung-chart","verlag-selector":"verlag-selector","vca-fehler-fixer":"vca-fehler-fixer"}[chunkId]||chunkId) + "." + {"about":"cda87eb9","app-side-navigation":"91d3be70","buch-bestell":"31d6cfe0","buch-listen":"31d6cfe0","buchscanner~buchverlagsverkaeufe~buecher~convenience-verkauf~datumsbereich-auswahl~presse-rechnung-k~1ce77264":"c9f5a90d","buchscanner":"4bcd6af4","buchverlagsverkaeufe~convenience-verkauf~datumsbereich-auswahl~kassencheck~presse-rechnung-kopf~rega~93e962c2":"31d6cfe0","buchverlagsverkaeufe~convenience-verkauf~vca-fehler-liste~verlag-selector~wfmonitor":"66535525","buchverlagsverkaeufe~vca-fehler-liste":"d253099c","buchverlagsverkaeufe":"53786724","convenience-verkauf~datumsbereich-auswahl~presse-rechnung-kopf":"7c4d4dfa","convenience-verkauf":"75fbc0a7","wfmonitor":"b1679bb6","regalkontrolle":"ae860dc9","buecher":"de69aa5f","kassencheck":"6c0e4b2e","presse-rechnungen":"31d6cfe0","statistiken":"31d6cfe0","vca-fehler":"864f4724","zeitschriften":"31d6cfe0","BuchListenListe":"31d6cfe0","BuchVerlagsVerkaeufeDetail":"de648bae","BuchungsMonitorDetail":"6b2bac16","BarcodeButton":"8733e87b","BuchAnzeige":"f5f6d7bb","ConvenienceAnzeige":"2dfb8bee","PresseAnzeige":"c0a76641","presse-rechnung-kopf":"b1950700","liste-unfertige-rechnungen":"13b452ed","datumsbereich-auswahl":"1665dc9b","vca-fehler-liste":"8ff3d8b0","excel-support":"31d6cfe0","bewegung-chart":"e5ef006b","verlag-selector":"49830f27","vca-fehler-fixer":"ff8feef4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
